import React from 'react';

import { MultiSelect, MultiSelectProps } from '@mantine/core';

/**
 * The four staff-facing payment method categories.
 *
 * Values are the API tokens consumed by the `payment_methods` query param, not
 * stored payment method types — the backend owns that mapping (see
 * `PaymentMethodCategories` in kilo_models). A new Stripe payment type is a
 * backend-only change; this list does not move.
 *
 * "Unknown" is deliberately absent: it means no payment method is on file, not
 * a way of paying, so it is not offered and those invoices drop out whenever
 * any category is selected.
 */
export const PAYMENT_METHOD_CATEGORIES = [
  { value: 'CARD', label: 'Card', 'data-cy': 'paymentMethodCardOption' },
  { value: 'BANK_ACCOUNT', label: 'Bank Account', 'data-cy': 'paymentMethodBankAccountOption' },
  { value: 'CASH_OR_CHECK', label: 'Cash or Check', 'data-cy': 'paymentMethodCashOrCheckOption' },
  { value: 'OTHER', label: 'Other', 'data-cy': 'paymentMethodOtherOption' },
];

const PaymentMethodMultiSelect = ({ ...multiSelectProps }: Omit<MultiSelectProps, 'data'>): JSX.Element => (
  <MultiSelect data={PAYMENT_METHOD_CATEGORIES} {...multiSelectProps} />
);

export default PaymentMethodMultiSelect;
